import React, { Component } from 'react'
import '../stylesheets/welcomeslide.css'
export default class WelcomeSlide extends Component {
    constructor(props){
        super(props)
        this.state={
           bgcolors:["blue","red","green"],
           color:null,
            i:0,
            count:setInterval(() => {
                if(this.state.i>2){
                    this.setState({
                        i:0
                    })
                }
                this.setState({
                    color:this.state.bgcolors[this.state.i],
                    i:this.state.i+1,
                })
            },1000)
         
        }
    }
    render() {
       
        let col = this.state.color
        return (
            
            <div className="slide-container" data-aos="fade-in">
              <div className="title">
              <h2><span style={{color:"red"}}>Ai</span><span style={{color:"Green"}}>Gen</span></h2> 
               <p >presents</p>
               
               <h3>world's first <span style={{color:"red"}}>AI</span> powered <span style={{color:col}}  >Mouse</span></h3>
              </div>
            </div>
        )
    }
}
